module.exports = __webpack_public_path__ + "static/media/menuItemIcon.13ac8965.svg";